<template>
  <div v-if="productInventoryStatus">
    <VChip
      :disabled="text"
      :color="color"
      :variant=" text ? 'text': undefined"
      :class="{
        'text':text,
        'font12':small
      }"
      data-testid="chip"
    >
      <span>{{ productInventoryStatus }}</span>
    </VChip>
    <STooltip v-if="tooltipText" :size="small ? '12' : '14'" callout :color="color">
      {{ tooltipText }}
    </STooltip>
  </div>
</template>

<script lang="ts" setup>
import { useInventoryStatus } from '~/composables/inventoryStatus'

interface Props {
 text?: boolean
 inventoryStatus?: string
 small?: boolean
 color?: string
}

const props = withDefaults(defineProps<Props>(), {
  text: false,
 inventoryStatus: undefined,
  small: false,
  color: 'white'
})

const i18n = useI18n()
const productInventoryStatus = computed(() => useInventoryStatus(props.inventoryStatus))

const tooltipText = computed(() => {
  const tooltipStatues = ['backordered']
 const status = props.inventoryStatus?.toLowerCase()
  if (status && tooltipStatues.includes(status)) {
    return i18n.ts(`inventoryStatus.tooltip.${status}`)
  }
  return undefined
})
</script>

<style lang="scss" scoped>
  .v-chip.text {
    background-color: transparent;
    opacity: inherit;
    padding: 0;
    height: auto;

    &.font12 {
      line-height: 20px;
      letter-spacing: 0.1px;
    }
  }
</style>
